/**
 * One-time migration for the 0001-sidebar-restructure feature-plan: the old
 * `.button-expand` toggle that used to write `sidebarNavigationState` was
 * removed, but the new width-based `@container` sidebar logic (ha-app.
 * component.ts's `_isSidebarCollapsed`) still READS the old persisted value
 * and applies `.collapsed`/`?collapsed=` accordingly. Anyone who had
 * collapsed the sidebar before this migration lands would otherwise be stuck
 * in icon-only mode forever, with no UI path back (stefan-todos finding
 * 0001-sidebar-restructure-01, MAJOR).
 *
 * Runs exactly once per browser, gated by its own flag key — a user's
 * genuine choice made AFTER this migration must never be silently reset
 * again on a later visit.
 */

const STATE_KEY = 'ha_sidebarNavigationState';
const MIGRATION_FLAG_KEY = 'ha_sidebarNavigationState-migrated-0001';

export function migrateSidebarNavigationState(): void {
    // Guards a non-browser environment (SSR, or a test importing app.state.ts
    // without stubbing localStorage) — always defined in a real browser.
    if (typeof localStorage === 'undefined') {
        return;
    }
    if (localStorage.getItem(MIGRATION_FLAG_KEY)) {
        return;
    }
    localStorage.removeItem(STATE_KEY);
    localStorage.setItem(MIGRATION_FLAG_KEY, 'true');
}
